<template>
  <div>
    <SearchableTable
      :panel-header="'Personen'"
      :panel-route="'AddPerson'"
      :show-search-bar="true"
      :table-data="persons"
      :table-meta-data="tableMetaData"
      :query-string="'setPersonSearchQuery'"
      :initial-search-query="personSearchQuery"
      :row-click="triggerView"
      :default-sort="['attributes.last_name', 'asc']"
    />
  </div>
</template>

<script>
import SearchableTable from "../helperComponents/SearchableTable.vue";
import { mapGetters } from "vuex";

export default {
	name: "Persons",
	components: { SearchableTable },
	data() {
		return {
			tableMetaData: [
				{ "id": 0, "type": "name", "label": "Name", "sortField": "attributes.last_name" },
				{ "id": 1, "type": "string", "label": "Email", "field": "email", "sortField": "attributes.email" },
				{ "id": 2, "type": "string", "label": "Typ", "field": "type", "sortField": "attributes.type" }
			]
		}
	},
	computed: {
		...mapGetters({
			persons: "getPersonFiltered",
			personSearchQuery: "getPersonSearchQuery"
		})
	},
	methods: {
		triggerView(person) {
			this.$router.push(
				{ name: "ViewPerson", params: { id: person.id, data: person } });
		}
	}
}
</script>

<style scoped></style>
